import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ILogin } from "../../types/AuthSliceTypes.ts";
import { IAuthSlice } from "../../interfaces/others/IAuthSlice.ts";
import { IUser } from "../../models/User.ts";
import { Partner } from "../../models/Partner.ts";

const initialState: IAuthSlice = {
  token: "",
  user: {} as IUser,
  isAdmin: false,
  partner: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<ILogin>) => {
      // console.log(action.payload)
      // return
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isAdmin = action.payload.rol === "Administrador" || action.payload.rol === "Administrador-";
      state.partner = action.payload.partner ?? state.partner ?? null;
    },
    setPartner: (state, action: PayloadAction<Partner | null>) => {
      state.partner = action.payload;
    },
    logout: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { login, logout, setPartner } = authSlice.actions;

export default authSlice.reducer;
